import React, { Component } from 'react';
import DenominacionEmpresa from './DenominacionEmpresa';
import DescripcionEmpresa from './DescripcionEmpresa';
import EsConfidencial from './EsConfidencial';
import Domicilio from './Domicilio';
import DestinatarioReportes from './DestinatarioReportes';
import HomeBanking from './HomeBanking';
import LimitesCompra from './LimitesCompra';
import Cartera from './Cartera';
import Rubros from './Rubros';
import Adelantos from './Adelantos';
import LimiteTransaccion from './LimiteTransaccion';
import ConsumoExterior from './ConsumoExterior';
import Cuotas from './Cuotas';
import ReporteCuentaCentral from './ReporteCuentaCentral';
import ResumenModeloLiquidacion from './ResumenModeloLiquidacion';
import Renovacion from './Renovacion';
import ValorRenovar from './ValorRenovar';
import Vigencia from './Vigencia';
import FechaTopeAgro from './FechaTopeAgro';
import VigenciaAlta from './VigenciaAlta';
import VigenciaRenovacion from './VigenciaRenovacion';

class Body extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        let props = this.props;

        let vigencias = undefined;
        let vigenciaAlta = props.data.empresaDatos.VigenciaDesdeAlta;
        let vigenciaRenovacion = props.data.empresaDatos.VigenciaDesdeLaRenovaccion;

        let vigenciasComponentes = <div>
            <Vigencia data={props.data} form={props.form} codigoNovedad="VIGPL_EMPR"
                changeDate={props.changeDate}
                changeDataError={props.changeDataError}
                cancelar={props.cancelar}
                guardarNovedad={props.guardarNovedad}
                estadoEdicion={props.estadoEdicion}

                mostrarModal={() => props.mostrarModal(true, "la Vigencia de los plásticos", props.data.entidadTipo, "VIGPL_EMPR", props.data.empresaDatos.Id)}
                actualizarNovedadEstado={props.actualizarNovedadEstado} />

            {(this.props.data.empresaDatos.EmpresaVisaTipoCodigo == "A") &&
                <FechaTopeAgro data={props.data} form={props.form} codigoNovedad="FETOP_EMPR"
                    changeDate={props.changeDate}
                    changeDataError={props.changeDataError}
                    cancelar={props.cancelar}
                    guardarNovedad={props.guardarNovedad}
                    estadoEdicion={props.estadoEdicion}

                    mostrarModal={() => props.mostrarModal(true, "Fecha tope Agro", props.data.entidadTipo, "FETOP_EMPR", props.data.empresaDatos.Id)}
                    actualizarNovedadEstado={props.actualizarNovedadEstado} />}

        </div>

        //Objeto de la novedad si tiene
        if (this.props.data.novedadEmpresaValorAlRenovar) {
            //Decide si es false o true la novedad
            switch (props.data.cobraValorRenovacion) {
                case true:
                    vigencias = vigenciasComponentes;
                    break;
                case false:
                    if (this.props.data.novedadEmpresaValorAlRenovar.ValorNovedad == "1") {
                        vigencias = vigenciasComponentes;
                    }
                    else {
                        if (props.data.seEstaEditandoValorRenovacion && props.data.empresaDatos.CobraValorRenovacion) {
                            vigencias = vigenciasComponentes;
                        }
                    }
                    break;
            }
        }
        else {
            //Si presiona check habilita los demas componentes
            switch (props.data.empresaDatos.CobraValorRenovacion) {
                case true:
                    vigencias = vigenciasComponentes;
                    break;
            }
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <DescripcionEmpresa
                        data={props.data}
                        form={this.props.form} />

                    <DenominacionEmpresa data={props.data} form={props.form} codigoNovedad="DENOM_EMPR"
                        changeInput={this.props.changeInput}
                        cancelar={this.props.cancelar}
                        guardarNovedad={this.props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}

                        mostrarModal={() => this.props.mostrarModal(true, "Denominación de la empresa", props.data.entidadTipo, "DENOM_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={this.props.actualizarNovedadEstado} />

                    <EsConfidencial data={props.data} form={props.form} codigoNovedad="ESCON_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}

                        mostrarModal={() => this.props.mostrarModal(true, "Confidencial", props.data.entidadTipo, "ESCON_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={this.props.actualizarNovedadEstado} />

                    <Domicilio data={props.data} form={props.form} codigoNovedad="DOMIC_EMPR"
                        selectCombo={props.selectCombo}
                        cancelar={props.cancelar}
                        guardarNovedades={props.guardarNovedades}
                        estadoEdicion={this.props.estadoEdicion}
                        guardarCampo={this.props.guardarCampo}

                        mostrarModal={() => this.props.mostrarModal(true, "Domicilio", props.data.entidadTipo, "DOMIC_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstados={this.props.actualizarNovedadEstados} />

                    <DestinatarioReportes data={props.data}
                        form={props.form}
                        codigoNovedad="DESTI_EMPR"
                        changeInput={props.changeInput}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "Destinatario de los reportes", props.data.entidadTipo, "DESTI_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <HomeBanking data={props.data}
                        form={props.form}
                        codigoNovedad="NUECL_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "la clave del home banking", props.data.entidadTipo, "NUECL_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <LimitesCompra data={props.data} form={props.form} codigoNovedad="LIMCO_EMPR" />

                    <Cartera carteraDescripcion={props.data.empresaDatos.CarteraDescripcion} />

                    <Rubros data={props.data} form={props.form} codigoNovedad="RUBRO_EMPR"
                        filtroRubro={props.filtroRubro}
                        changeRubro={props.changeRubro}
                        cancelar={props.cancelar}
                        guardarNovedades={this.props.guardarNovedades}
                        estadoEdicion={this.props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "Rubros en los que puede comprar", props.data.entidadTipo, "RUBRO_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstados={props.actualizarNovedadEstados} />

                    <Adelantos data={props.data} form={props.form} codigoNovedad="PERAD_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "Permite Adelantos", props.data.entidadTipo, "PERAD_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <LimiteTransaccion data={props.data} form={props.form} codigoNovedad="LIMTR_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "límite por transacción", props.data.entidadTipo, "LIMTR_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <ConsumoExterior data={props.data} form={props.form} codigoNovedad="CONEX_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "consumos en el exterior", props.data.entidadTipo, "CONEX_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <Cuotas data={props.data} form={props.form} />

                    <ReporteCuentaCentral data={props.data} form={props.form} codigoNovedad="REPCU_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "reporte cuenta central", props.data.entidadTipo, "REPCU_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <ResumenModeloLiquidacion data={props.data} form={props.form} codigoNovedad="MODLI_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}

                        mostrarModal={() => props.mostrarModal(true, "los gastos de emisión del resumen del modelo de liquidación", props.data.entidadTipo, "MODLI_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <Renovacion
                        codigoPrecioRenovacion={props.data.empresaDatos.CodigoPrecioRenovacion}
                        codigoNovedad="BONRE_EMPR"
                        data={{
                            porcentajeBonificacionId: props.data.empresaDatos.PorcentajeBonificacionRenovacion,
                            porcentajeBonificacionAlta: props.data.empresaDatos.PorcentajeBonificacionAlta
                        }}
                        entidadId={props.data.empresaDatos.Id}
                        esNovedadEditada={props.data.esNovedadEditada.find(x => x.campoCodigo == "BONRE_EMPR").editado}
                        funcionesDelUsuario={props.data.funcionesDelUsuario}
                        novedades={(props.data.novedadesEmpresaDatos || []).filter(n => n.NovedadCampoCodigo == "BONRE_EMPR")}
                        seEstaEditando={props.data.seEstaEditando}
                        bonificacionesRenovacion={props.data.atlasBonificacionRenovacion}

                        selectCombo={props.selectCombo}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}
                        mostrarModal={() => props.mostrarModal(true, "Bonificación de la renovación", props.data.entidadTipo, "BONRE_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <ValorRenovar data={props.data} form={props.form} codigoNovedad="ACTRE_EMPR"
                        changeCheck={props.changeCheck}
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}
                        mostrarModal={() => props.mostrarModal(true, "valor al renovar", props.data.entidadTipo, "ACTRE_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    {vigencias}

                    <VigenciaAlta data={props.data}
                        changeInput={this.props.changeInput}
                        form={props.form}
                        codigoNovedad="VIG_A_EMPR"
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}
                        mostrarModal={() => props.mostrarModal(true, "Vigencia de Alta", props.data.entidadTipo, "VIG_A_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado} />

                    <VigenciaRenovacion data={props.data}
                        changeInput={this.props.changeInput}
                        form={props.form}
                        codigoNovedad="VIG_R_EMPR"
                        cancelar={props.cancelar}
                        guardarNovedad={props.guardarNovedad}
                        estadoEdicion={this.props.estadoEdicion}
                        mostrarModal={() => props.mostrarModal(true, "Vigencia de Renovacion", props.data.entidadTipo, "VIG_R_EMPR", props.data.empresaDatos.Id)}
                        actualizarNovedadEstado={props.actualizarNovedadEstado}/>
                </div>
            </div>
        );
    }
};

export default Body;

